import React from "react"
import { Cell } from "fixed-data-table-2"
import { patchColumnData } from "sheets/sheet-action-creators"
import { connect } from "react-redux"
import Icon from "app/static/frontend/components/Icon"
import PropTypes from "prop-types"
export const CheckCell = ({
    children,
    columnIsEditable,
    sheetId,
    rowId,
    columnId,
    cellIsEditable,
    cellValueIsNotEditable,
    ...props
}) => (
    <div className="text-center check-cell">
        <Cell {...props}>
            <Icon
                style={columnIsEditable && cellIsEditable ? { cursor: "pointer" } : {}}
                name={children && !cellValueIsNotEditable ? "check-square-o" : "square-o"}
                onClick={() =>
                    columnIsEditable && cellIsEditable
                        ? props.patchColumnData({
                              id: sheetId,
                              columnId,
                              rowId,
                              newValue: !children,
                          })
                        : false
                }
            />
        </Cell>
    </div>
)

CheckCell.propTypes = {
    children: PropTypes.bool,
    columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    columnIsEditable: PropTypes.bool,
    patchColumnData: PropTypes.func.isRequired,
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sheetId: PropTypes.string.isRequired,
}

CheckCell.defaultProps = {
    columnIsEditable: false,
}

export default connect(null, { patchColumnData })(CheckCell)
